import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';

import { ApiService } from '../core/upgraded-providers';

@Injectable()
export class WorldMapStartRoomResolver implements Resolve<any> {
    constructor(
        private _apiService: ApiService
    ) {
    }

    resolve(route: ActivatedRouteSnapshot): Promise<any> {
        let params = {};

        const { shard } = route.params;
        if (shard) {
            params = { shard };
        }

        return new Promise(async (resolve) => {
            try {
                const data = await this._apiService.get('user/world-start-room', params);
                const room = data.room ? data.room : [];

                resolve(room);
            } catch (err) {
                // TODO: Need to add handler for world start room error.
                // reject();
            }
        });
    }
}
